/* eslint-disable max-lines */
// tslint:disable:max-file-line-count
import { IRoadInfoSchema } from '../repositories/countryside-search/entities/road/RoadInfoSchema';
import { IBuilderSchema } from '../repositories/countryside-search/entities/schemas/BuilderSchema';
import { IGetVillageResponseSchema as IGetVillageResponse } from '../repositories/countryside-search/entities/schemas/GetVillageResponseSchema';
import { IVillageSchema as IVillage } from '../repositories/countryside-search/entities/schemas/VillageSchema';
import { NonNullableObject } from '../utils/helpers';

export { IVillageCounterSetSchema } from '../repositories/countryside-search/entities/counter/VillageCounterSetSchema';
export { IGeoAddressDetailsSchema } from '../repositories/countryside-search/entities/geo/GeoAddressDetailsSchema';
export { ICommunicationSetSchema } from '../repositories/countryside-search/entities/communication/CommunicationSetSchema';
export { INeighbourhoodSchema } from '../repositories/countryside-search/entities/neighbourhood/NeighbourhoodSchema';
export { INewobjectCategorySchema } from '../repositories/countryside-search/entities/newobject_category/NewobjectCategorySchema';
export { INewobjectCategorySetSchema } from '../repositories/countryside-search/entities/newobject_category/NewobjectCategorySetSchema';
export { IGeoAddressSchema } from '../repositories/countryside-search/entities/geo/GeoAddressSchema';
export { IGeoSchema } from '../repositories/countryside-search/entities/schemas/GeoSchema';
export { IVideoSchema } from '../repositories/countryside-search/entities/video/VideoSchema';
export { IImageSchema as IPhotoSchema } from '../repositories/countryside-search/entities/gallery/ImageSchema';
export { IGallerySchema as IVillageGallerySchema } from '../repositories/countryside-search/entities/gallery/GallerySchema';
export { IStationInfoSchema } from '../repositories/countryside-search/entities/station_info/StationInfoSchema';
export { IRelatedVillageSchema } from '../repositories/countryside-search/entities/schemas/RelatedVillageSchema';
export { IBreadcrumbSchema } from '../repositories/countryside-search/entities/schemas/BreadcrumbSchema';

export { IRoadInfoSchema, IGetVillageResponse, IBuilderSchema };

export interface IGetVillageResponseSchema extends Omit<IGetVillageResponse, 'village'> {
  village: IVillageSchema;
}

export interface IVillageSchema extends Omit<IVillage, 'coordinates'> {
  coordinates: {
    lat: number;
    lng: number;
  };
}
export type TCanalizationCommunications = 'local' | 'central' | '';

export const CanalizationCommunicationTypes = {
  Central: 'central' as TCanalizationCommunications,
  Local: 'local' as TCanalizationCommunications,
};

export const CanalizationCommunicationNames = {
  [CanalizationCommunicationTypes.Local]: 'локальная',
  [CanalizationCommunicationTypes.Central]: 'центральная',
};

export type TGasCommunications = 'balloon' | 'magistral';

export const GasCommunicationTypes = {
  Balloon: 'balloon' as TGasCommunications,
  Magistral: 'magistral' as TGasCommunications,
};

export const GasCommunicationNames = {
  [GasCommunicationTypes.Balloon]: 'баллоны',
  [GasCommunicationTypes.Magistral]: 'магистраль',
};

export type THeatingCommunications = 'boiler' | 'central' | 'electrical';

export const HeatingCommunicationTypes = {
  Boiler: 'boiler' as THeatingCommunications,
  Central: 'central' as THeatingCommunications,
  Electrical: 'electrical' as THeatingCommunications,
};

export const HeatingCommunicationNames = {
  [HeatingCommunicationTypes.Boiler]: 'котел (газ)',
  [HeatingCommunicationTypes.Central]: 'центральное',
  [HeatingCommunicationTypes.Electrical]: 'электрообогрев',
};

export type TElectricityCommunications = 'yes' | '';

export type TRoadCommunications = 'asphaltic' | 'concrete' | 'dirt' | 'trunk' | 'gravel' | 'crushedAsphalt';

export const RoadCommunicationTypes = {
  Asphaltic: 'asphaltic' as TRoadCommunications,
  Concrete: 'concrete' as TRoadCommunications,
  Dirt: 'dirt' as TRoadCommunications,
  Rubble: 'rubble' as TRoadCommunications,
  Trunk: 'trunk' as TRoadCommunications,
  Gravel: 'gravel' as TRoadCommunications,
  CrushedAsphalt: 'crushedAsphalt' as TRoadCommunications,
};

export const RoadCommunicationNames = {
  [RoadCommunicationTypes.Asphaltic]: 'асфальтированная',
  [RoadCommunicationTypes.Concrete]: 'бетонная',
  [RoadCommunicationTypes.Dirt]: 'грунтовая',
  [RoadCommunicationTypes.Rubble]: 'щебёнка',
  [RoadCommunicationTypes.Trunk]: 'магистральная',
  [RoadCommunicationTypes.Gravel]: 'гравийная',
  [RoadCommunicationTypes.CrushedAsphalt]: 'асфальтовая крошка',
};

export type TGeoType = 'country' | 'district' | 'house' | 'location' | 'street' | 'underground';

export interface IVillageSeoData {
  url: string;
}

export type TModerationStatus = IBuilderSchema['moderationStatus'];

export const MODERATION_STATUS_TYPES = {
  Deleted: 'deleted' as TModerationStatus,
  Draft: 'draft' as TModerationStatus,
  Published: 'published' as TModerationStatus,
};

export interface IBuilderSeoDataSchema {
  onSale?: ISeoDataSchema;
  sold?: ISeoDataSchema;
  underConstruction?: ISeoDataSchema;
}

export interface IBuilderCounterSetSchema {
  onSale: number;
  underConstruction: number;
  sold: number;
}

export type TVillageClass = 'economy' | 'comfort' | 'business' | 'elite';

export enum FeatureTypes {
  nature = 'Природа',
  social = 'Социальный элемент',
  location = 'Расположение',
  construction = 'Материалы и строительство',
}

export interface IFeatureSchema {
  description: string;
  imageUrl: string;
  type: keyof typeof FeatureTypes;
}

export type TCommute = 'kad' | 'mkad';

export interface ISeoDataSchema {
  url: string;
}

export type TVillageInfrastructure =
  | 'playground'
  | 'rest'
  | 'resort'
  | 'cinema'
  | 'theater'
  | 'lake'
  | 'river'
  | 'gulf'
  | 'pond'
  | 'park'
  | 'reserve'
  | 'forest'
  | 'kindergarten'
  | 'school'
  | 'institute'
  | 'studio'
  | 'polyclinic'
  | 'hospital'
  | 'clinic'
  | 'pharmacy'
  | 'veterinaryClinic'
  | 'dogsWalking'
  | 'zoo'
  | 'sportsGround'
  | 'fitness'
  | 'spa'
  | 'pool'
  | 'stadium'
  | 'police'
  | 'fire'
  | 'perimeter'
  | 'video'
  | 'access'
  | 'security'
  | 'concierge'
  | 'guardedParking'
  | 'signaling'
  | 'supermarket'
  | 'shop'
  | 'restaurant'
  | 'shoppingCenter'
  | 'church'
  | 'museum'
  | 'square'
  | 'carService'
  | 'gasStation'
  | 'commercial'
  | 'office'
  | 'selfService'
  | 'parking';

export const VillageInfrastructureTypes = {
  Access: 'access' as TVillageInfrastructure,
  CarService: 'carService' as TVillageInfrastructure,
  Church: 'church' as TVillageInfrastructure,
  Cinema: 'cinema' as TVillageInfrastructure,
  Clinic: 'clinic' as TVillageInfrastructure,
  Commercial: 'commercial' as TVillageInfrastructure,
  Concierge: 'concierge' as TVillageInfrastructure,
  DogsWalking: 'dogsWalking' as TVillageInfrastructure,
  Fire: 'fire' as TVillageInfrastructure,
  Fitness: 'fitness' as TVillageInfrastructure,
  Forest: 'forest' as TVillageInfrastructure,
  GasStation: 'gasStation' as TVillageInfrastructure,
  GuardedParking: 'guardedParking' as TVillageInfrastructure,
  Gulf: 'gulf' as TVillageInfrastructure,
  Hospital: 'hospital' as TVillageInfrastructure,
  Institute: 'institute' as TVillageInfrastructure,
  KinderGarten: 'kindergarten' as TVillageInfrastructure,
  Lake: 'lake' as TVillageInfrastructure,
  Museum: 'museum' as TVillageInfrastructure,
  Office: 'office' as TVillageInfrastructure,
  Park: 'park' as TVillageInfrastructure,
  Parking: 'parking' as TVillageInfrastructure,
  Perimeter: 'perimeter' as TVillageInfrastructure,
  Pharmacy: 'pharmacy' as TVillageInfrastructure,
  Playground: 'playground' as TVillageInfrastructure,
  Police: 'police' as TVillageInfrastructure,
  Polyclinic: 'polyclinic' as TVillageInfrastructure,
  Pond: 'pond' as TVillageInfrastructure,
  Pool: 'pool' as TVillageInfrastructure,
  Reserve: 'reserve' as TVillageInfrastructure,
  Resort: 'resort' as TVillageInfrastructure,
  Rest: 'rest' as TVillageInfrastructure,
  Restaurant: 'restaurant' as TVillageInfrastructure,
  River: 'river' as TVillageInfrastructure,
  School: 'school' as TVillageInfrastructure,
  Security: 'security' as TVillageInfrastructure,
  SelfService: 'selfService' as TVillageInfrastructure,
  Shop: 'shop' as TVillageInfrastructure,
  ShoppingCenter: 'shoppingCenter' as TVillageInfrastructure,
  Signaling: 'signaling' as TVillageInfrastructure,
  Spa: 'spa' as TVillageInfrastructure,
  SportsGround: 'sportsGround' as TVillageInfrastructure,
  Square: 'square' as TVillageInfrastructure,
  Stadium: 'stadium' as TVillageInfrastructure,
  Studio: 'studio' as TVillageInfrastructure,
  Supermarket: 'supermarket' as TVillageInfrastructure,
  Theater: 'theater' as TVillageInfrastructure,
  VeterinaryClinic: 'veterinaryClinic' as TVillageInfrastructure,
  Video: 'video' as TVillageInfrastructure,
  Zoo: 'zoo' as TVillageInfrastructure,
};

export const VillageInfrastructureNames = {
  [VillageInfrastructureTypes.Playground]: 'Детские площадки',
  [VillageInfrastructureTypes.Rest]: 'Места для отдыха',
  [VillageInfrastructureTypes.Resort]: 'Курортная зона',
  [VillageInfrastructureTypes.Cinema]: 'Кино',
  [VillageInfrastructureTypes.Theater]: 'Театр',
  [VillageInfrastructureTypes.Lake]: 'Озеро',
  [VillageInfrastructureTypes.River]: 'Река',
  [VillageInfrastructureTypes.Gulf]: 'Залив',
  [VillageInfrastructureTypes.Pond]: 'Пруд',
  [VillageInfrastructureTypes.Park]: 'Парковая зона',
  [VillageInfrastructureTypes.Reserve]: 'Заповедник',
  [VillageInfrastructureTypes.Forest]: 'Лесная зона',
  [VillageInfrastructureTypes.KinderGarten]: 'Детский сад',
  [VillageInfrastructureTypes.School]: 'Школа',
  [VillageInfrastructureTypes.Institute]: 'Институт',
  [VillageInfrastructureTypes.Studio]: 'Студии',
  [VillageInfrastructureTypes.Polyclinic]: 'Поликлиника',
  [VillageInfrastructureTypes.Hospital]: 'Больница',
  [VillageInfrastructureTypes.Clinic]: 'Медпункт',
  [VillageInfrastructureTypes.Pharmacy]: 'Аптеки',
  [VillageInfrastructureTypes.VeterinaryClinic]: 'Ветеринарная клиника',
  [VillageInfrastructureTypes.DogsWalking]: 'Площадки для выгула собак',
  [VillageInfrastructureTypes.Zoo]: 'Зоопарк',
  [VillageInfrastructureTypes.SportsGround]: 'Спортивные площадки',
  [VillageInfrastructureTypes.Fitness]: 'Фитнес-центр',
  [VillageInfrastructureTypes.Spa]: 'SPA-центр',
  [VillageInfrastructureTypes.Pool]: 'Бассейн',
  [VillageInfrastructureTypes.Stadium]: 'Стадион',
  [VillageInfrastructureTypes.Police]: 'Полиция',
  [VillageInfrastructureTypes.Fire]: 'Пожарная служба',
  [VillageInfrastructureTypes.Perimeter]: 'Огороженный периметр',
  [VillageInfrastructureTypes.Video]: 'Видеонаблюдение',
  [VillageInfrastructureTypes.Access]: 'Пропускная система',
  [VillageInfrastructureTypes.Security]: 'Круглосуточная охрана',
  [VillageInfrastructureTypes.Concierge]: 'Консьерж',
  [VillageInfrastructureTypes.GuardedParking]: 'Охраняемая парковка',
  [VillageInfrastructureTypes.Signaling]: 'Сигнализация',
  [VillageInfrastructureTypes.Supermarket]: 'Супермаркет',
  [VillageInfrastructureTypes.Shop]: 'Магазин',
  [VillageInfrastructureTypes.Restaurant]: 'Рестораны',
  [VillageInfrastructureTypes.ShoppingCenter]: 'Торговый центр',
  [VillageInfrastructureTypes.Church]: 'Церковь',
  [VillageInfrastructureTypes.Museum]: 'Музеи',
  [VillageInfrastructureTypes.Square]: 'Площади',
  [VillageInfrastructureTypes.CarService]: 'Автосервис',
  [VillageInfrastructureTypes.GasStation]: 'АЗС',
  [VillageInfrastructureTypes.Commercial]: 'Коммерческие объекты',
  [VillageInfrastructureTypes.Office]: 'Офисы',
  [VillageInfrastructureTypes.SelfService]: 'Бытовые услуги',
  [VillageInfrastructureTypes.Parking]: 'Парковки',
};

export type TWaterSupplyCommunications = 'central' | 'hole' | 'well';

export const WaterSupplyTypes = {
  Central: 'central' as TWaterSupplyCommunications,
  Hole: 'hole' as TWaterSupplyCommunications,
  Well: 'well' as TWaterSupplyCommunications,
};

export const WaterSupplyCommunicationNames = {
  [WaterSupplyTypes.Central]: 'центральное',
  [WaterSupplyTypes.Hole]: 'скважина',
  [WaterSupplyTypes.Well]: 'колодец',
};

export interface IFatFeature {
  id?: number | null;
  text?: string | null;
  imageUrl?: string | null;
}

export type TFatFeatureModel = NonNullableObject<IFatFeature>;
